var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { Badge, TextField, Typography, Alert, } from '@one-thd/sui-atomic-components';
import { Controller, useController } from 'react-hook-form';
import { TextButton } from '../../shared/text-button/text-button';
import { getTextFieldStatus } from '../../../utils/form';
import { T2CStatus } from '../../../constants/payments';
import { getHyphenatedPhoneNumber } from '../../../utils/general';
import { TAlertStatus, } from '../../../models/common/alert-messages';
import { ERR_GENERIC } from '../../../constants/response-error-messages';
import { RESEND_INVITE_SUCCESS_MSG } from '../../../constants/response-success-messages';
import { track } from '../../../utils/analytics';
import { AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK } from '../../../constants/analytics';
export const InputFieldsRow = ({ control, index, onRemove, onResend, }) => {
    const shouldShowRemoveButton = index !== 0;
    const { field } = useController({ name: 'additionalApprovers', control });
    const [pending, setPending] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const showAlert = !!alertMessage;
    useEffect(() => {
        const isPending = field.value.length !== 0 &&
            field.value[index].status === T2CStatus.PENDING;
        setPending(isPending);
    }, [field, index]);
    const handleResend = () => {
        onResend()
            .then((success) => {
            if (success) {
                const t2cNumber = field.value[index].t2cNumber;
                setAlertMessage({
                    alertStatus: TAlertStatus.SUCCESS,
                    text: RESEND_INVITE_SUCCESS_MSG.message + t2cNumber,
                });
                track(AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK, {
                    section: 'authorize remote purchases overlay',
                    actionType: 'resend text2confirm invite',
                });
            }
            else {
                setAlertMessage({
                    alertStatus: TAlertStatus.ERROR,
                    text: ERR_GENERIC.message,
                });
            }
        })
            .catch(() => {
            setAlertMessage({
                alertStatus: TAlertStatus.ERROR,
                text: ERR_GENERIC.message,
            });
        });
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-1 sui-mt-4" },
        pending && showAlert && (React.createElement(Alert, { status: alertMessage.alertStatus },
            React.createElement(Typography, { variant: "body-base" }, alertMessage.text))),
        React.createElement("div", { className: "sui-flex sui-gap-4 sui-flex-col md:sui-flex-row" },
            React.createElement(Controller, { name: `additionalApprovers.${index}.fullName`, control: control, render: (_a) => {
                    var _b = _a.field, { ref, onChange, value, name, disabled } = _b, restFields = __rest(_b, ["ref", "onChange", "value", "name", "disabled"]), { fieldState: { error } } = _a;
                    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full" },
                        React.createElement("div", { className: "sui-flex sui-justify-between sui-items-center sui-w-full sui-cursor-default" },
                            React.createElement("div", { className: "sui-h-6 sui-flex sui-items-center sui-w-full" },
                                React.createElement(Typography, { variant: "body-base" }, "Name*"),
                                pending && (React.createElement("div", { className: "sui-pl-2", "data-testid": "t2cPendingBadge" },
                                    React.createElement(Badge, { variant: "regular", color: "info", size: "small" }, "Pending")))),
                            pending && (React.createElement("div", { "data-testid": "t2cResendInvite" },
                                React.createElement(TextButton, { onClick: handleResend },
                                    React.createElement(Typography, { variant: "body-base" }, "Resend"))))),
                        React.createElement(TextField, { fullWidth: true, name: name, status: getTextFieldStatus(error), statusMessage: error === null || error === void 0 ? void 0 : error.message, defaultValue: value, value: value, disabled: disabled, InputProps: Object.assign({ 'data-qm-mask': '', onChange: (event) => {
                                    onChange(event);
                                } }, restFields) })));
                } }),
            React.createElement(Controller, { name: `additionalApprovers.${index}.t2cNumber`, control: control, render: (_a) => {
                    var _b = _a.field, { ref, onChange, value, disabled, name } = _b, restFields = __rest(_b, ["ref", "onChange", "value", "disabled", "name"]), { fieldState: { error } } = _a;
                    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full" },
                        React.createElement("div", { className: "sui-h-6 sui-flex sui-items-center sui-justify-between sui-w-full sui-cursor-default" },
                            React.createElement(Typography, { variant: "body-base" }, "Mobile Number*"),
                            shouldShowRemoveButton && (React.createElement(TextButton, { onClick: () => {
                                    onRemove(index);
                                } },
                                React.createElement(Typography, { variant: "body-base" }, "Remove")))),
                        React.createElement(TextField, { name: name, fullWidth: true, status: getTextFieldStatus(error), statusMessage: error === null || error === void 0 ? void 0 : error.message, defaultValue: value, value: value, disabled: disabled, type: "tel", InputProps: Object.assign({ inputProps: { 'data-qm-mask': '' }, onChange: (event) => {
                                    setPending(false);
                                    onChange(getHyphenatedPhoneNumber(event.currentTarget.value));
                                } }, restFields) })));
                } }))));
};
